<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
           <v-btn absolute dark fab right bottom color="error" v-on="on" @click="findoutGroupsNumber">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="my-5">
                <h4 class="title blue-grey--text accent-4 font-italic">New Group</h4>
            </v-card-title>
            <v-card-text>
                <v-form v-model="valid" ref="form">
                    <v-text-field
                        v-model="name"
                        label="그룹이름"
                        :rules="nameRules"
                        hint="ex) 은탁선"
                        prepend-icon="mdi-account-badge-horizontal-outline"
                        required>
                    </v-text-field>
                    <v-text-field
                        v-model="region"
                        label="지역"
                        :rules="nameRules"
                        hint="ex) 용인 동백"
                        prepend-icon="mdi-map-marker"
                        required>
                    </v-text-field>
                    <p class="text-center caption pink--text" v-if="feedback">{{ feedback }}</p>
                    <v-row justify="center">
                        <v-btn :loading="loading" class="mt-5 blue-grey accent-4 white--text" @click="creatingGroup" :disabled="!valid">Create</v-btn>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
  
</template>

<script>
import slugify from 'slugify'
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'CreatingGroup',
  data: () => ({
    dialog: false,
    loading: false,
    valid: false,
    name: null,
    region: null,
    feedback: null,
    nameRules: [
        v => !!v || '이름은 꼭 필요해요!'
    ],
    slug: null,
    user: '',
    joinedGroups: [],
    groupsNumber: null,
    noUser: false    
  }),
  methods: {
        findoutGroupsNumber(){
            // find out the number of the groups
            db.collection('groups').get().then(snapshot => {
                if(snapshot.docs.length > 0 ){
                    this.groupsNumber = snapshot.docs.length;
                } else {
                    this.groupsNumber = 0;
                }
            })
        },
        creatingGroup(){
            if(this.user){
                if(this.$refs.form.validate()){

                    this.loading = true;

                    // change the name into slug
                    this.slug = slugify(this.name, {
                        replacement: '-',
                        remove: /[$*_+~.()'"!\-:@]/g,
                        lower: true
                    })

                    let joinedGroups = this.user.joinedGroups
                    // add a new group to the user info
                    joinedGroups.push({
                        id: this.slug,
                        history: [this.user.total],
                    })

                    // create a new group
                    let ref = db.collection('groups').doc(this.slug)
                    ref.get().then(doc => {
                        if(doc.exists){
                            this.feedback = "이 이름은 다른 그룹이 먼저 쓰고 있어요!";
                        } else {
                            ref.set({
                                name: this.name,
                                region: this.region,
                                creator: {
                                    name: this.user.name,
                                    alias: this.user.alias
                                },
                                timeStamp: Date.now(),
                                imgURL: this.user.avatar,
                                members: [{
                                    alias: this.user.alias,
                                    name: this.user.name,
                                    timeStamp: Date.now()
                                }]
                            })
                        }
                    }).then(() => {

                        // update the joinedGroups of the user's info
                        db.collection('users').doc(this.user.id).update({
                            joinedGroups: joinedGroups
                        })
                    })
                }
            
                this.dialog = false;
                this.loading = false;            
            
            } else {
               return false
            }            
        }
    },
    created(){

        // create user
        let user = firebase.auth().currentUser;
        if(user){
            // find the user record
            db.collection('users').where('user_id', '==', user.uid).get()
                .then(snapshot => {
                    snapshot.forEach(doc => {
                        this.user = {
                            ...doc.data(),
                            id: doc.id
                        }

                    })
                })
        } else {
            return false
        }        
    }
};
</script>